/**
 * Product page functionality
 */

(function() {
  'use strict';

  class ProductPage {
    constructor() {
      this.form = document.querySelector('.product-form');
      this.variantSelects = document.querySelectorAll('.variant-selector');
      this.priceElement = document.querySelector('.product-price');
      this.addToCartButton = document.querySelector('.add-to-cart-btn');
      this.quantityInput = document.querySelector('.quantity-input');
      this.mainImage = document.querySelector('.product-main-image');
      this.thumbnails = document.querySelectorAll('.product-thumbnail');
      this.currentVariant = null;

      this.bindEvents();
      this.initGallery();
    }

    bindEvents() {
      // Variant selection
      this.variantSelects.forEach(select => {
        select.addEventListener('change', () => this.handleVariantChange());
      });

      // Quantity buttons
      const decreaseBtn = document.querySelector('.quantity-decrease');
      const increaseBtn = document.querySelector('.quantity-increase');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => this.updateQuantity(-1));
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => this.updateQuantity(1));
      }

      // Add to cart
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleAddToCart(e));
      }
    }

    initGallery() {
      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const imgSrc = thumb.dataset.fullImage;
          if (this.mainImage && imgSrc) {
            this.mainImage.src = imgSrc;
            this.thumbnails.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          }
        });
      });
    }

    handleVariantChange() {
      const selectedOptions = [];
      this.variantSelects.forEach(select => {
        selectedOptions.push(select.value);
      });

      // Find matching variant
      if (window.productVariants) {
        const variant = window.productVariants.find(v => {
          return v.options.every((opt, i) => opt === selectedOptions[i]);
        });

        if (variant) {
          this.currentVariant = variant;
          this.updatePrice(variant);
          this.updateAvailability(variant);
          this.updateURL(variant);
          this.updateImage(variant);
        }
      }
    }

    updatePrice(variant) {
      if (!this.priceElement) return;

      const price = Shopify.formatMoney?.(variant.price) || `₪${Math.floor(variant.price / 100)}`;
      this.priceElement.innerHTML = price;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const comparePrice = Shopify.formatMoney?.(variant.compare_at_price) || `₪${Math.floor(variant.compare_at_price / 100)}`;
        this.priceElement.innerHTML = `
          <span class="price-sale">${price}</span>
          <span class="price-compare">${comparePrice}</span>
        `;
      }
    }

    updateAvailability(variant) {
      if (!this.addToCartButton) return;

      if (variant.available) {
        this.addToCartButton.disabled = false;
        this.addToCartButton.textContent = 'הוסיפי לעגלה';
      } else {
        this.addToCartButton.disabled = true;
        this.addToCartButton.textContent = 'אזל מהמלאי';
      }
    }

    updateURL(variant) {
      if (window.history.replaceState && variant.id) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    updateImage(variant) {
      if (variant.featured_image && this.mainImage) {
        this.mainImage.src = variant.featured_image.src;
      }
    }

    updateQuantity(change) {
      if (!this.quantityInput) return;

      let value = parseInt(this.quantityInput.value) || 1;
      value = Math.max(1, value + change);
      this.quantityInput.value = value;
    }

    async handleAddToCart(e) {
      // Let cart-drawer.js handle the AJAX submission
      // This is for any additional product-specific logic
    }
  }

  // Size guide modal
  class SizeGuide {
    constructor() {
      this.trigger = document.querySelector('.size-guide-trigger');
      this.modal = document.querySelector('.size-guide-modal');

      if (this.trigger && this.modal) {
        this.bindEvents();
      }
    }

    bindEvents() {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      const closeBtn = this.modal.querySelector('.modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.close();
        }
      });
    }

    open() {
      this.modal.classList.add('modal--open');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.modal.classList.remove('modal--open');
      document.body.classList.remove('overflow-hidden');
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    new ProductPage();
    new SizeGuide();
  });

})();
